/* LUNEOR — scroll reveal: page elements fade/slide in little by little as you scroll */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && Shopify.designMode) return;
  // "reduce motion" visitors still get the soft fade, just without the upward movement
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = '.lrv{opacity:0;transform:translateY(' + (calm ? 0 : 28) + 'px);transition:opacity .8s ease,transform .9s cubic-bezier(.2,.7,.2,1)}' +
            '.lrv.lrv-in{opacity:1;transform:none}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var PICK = 'h1,h2,h3,h4,p,li,img,picture,video,figure,table,form,blockquote,.btn,.eyebrow,.feat .fm,.feat .ft,.card,.pcard,[class*="card"],.acc>div,.specs tr,.stat,.step,dl,.pworld>div,.trust>*,.ez-amrv-wrapp .container>*,.ez-amrv-wrapp [class*="review-item"],.ez-amrv-wrapp [class*="item-review"]';
  var SKIP = 'header,.header,#shopify-section-header,.sticky-atc,.lightbox,.drawer,#cart,.scrim,.marquee,[class*="marquee"],.mask,[hidden],[aria-hidden="true"],.skip,.visually-hidden,.sr-only,script,style,noscript,select,option,label,input,button:not(.btn)';

  var io = new IntersectionObserver(function (es) {
    var batch = es.filter(function (e) { return e.isIntersecting; });
    batch.forEach(function (e, i) {
      var el = e.target;
      el.style.transitionDelay = Math.min(i * 70, 420) + 'ms';
      el.classList.add('lrv-in');
      io.unobserve(el);
      setTimeout(function () { el.style.transitionDelay = ''; }, 1600);
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -5% 0px' });

  function belowFold(el) { return el.getBoundingClientRect().top > innerHeight - 10; }

  function scan() {
    var main = document.getElementById('main') || document.querySelector('main') || document.body;

    // big blocks that already fade in as one piece: let their contents come in one by one instead
    Array.prototype.forEach.call(main.querySelectorAll('.rv:not(.in)'), function (b) {
      if (b.closest(SKIP) || b.querySelectorAll(PICK).length < 2 || !belowFold(b)) return;
      b.classList.remove('rv');
    });

    Array.prototype.forEach.call(main.querySelectorAll(PICK), function (el) {
      if (el.classList.contains('lrv') || el.closest(SKIP) || el.closest('.rv') || el.querySelector('.rv,.mask')) return;
      if (el.offsetHeight < 8 || el.offsetWidth < 8) return;
      for (var p = el.parentElement; p && p !== main; p = p.parentElement) { if (p.classList.contains('lrv')) return; }
      if (!belowFold(el)) return;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') return;
      el.classList.add('lrv');
      io.observe(el);
    });
  }

  function start() {
    scan();
    // content added later (reviews widget, recommendations…)
    var t, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); });
    mo.observe(document.getElementById('main') || document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  // only what is below the screen gets hidden, so nothing visible ever blinks
  var started = false;
  function go() { if (!started) { started = true; start(); } }
  if (document.readyState === 'complete') go(); else { window.addEventListener('load', go); setTimeout(go, 2000); }
})();
